import { UserSetting } from '@oh-vcp/components-common';
import { useQuery } from 'react-query';
import apiService from './apiService';

const fetchUserSettings = async (
  userId: number | string,
  serviceType: string
): Promise<UserSetting[]> => {
  const response = await apiService.get(`users/${userId}/settings/${serviceType}`);
  return response.data;
};

const useUserSettings = (userId: number | string | undefined, serviceType: string) => {
  return useQuery({
    queryFn: () => fetchUserSettings(userId!, serviceType),
    queryKey: ['useUserSettings', userId, serviceType],
    enabled: !!userId && !!serviceType
  });
};

export default useUserSettings;
